export function orderByBoolean<T>([...array]: T[], fnc: (array: T) => boolean) {
    // Sort while keeping original order in the same group
    return splitByBoolean(array, fnc).flat();
}

export function splitByBoolean<T>(
    [...array]: T[],
    fnc: (value: T, index: number) => boolean
): [trueArray: T[], falseArray: T[]] {
    return array.reduce<[T[], T[]]>(
        (acc, val, i) => {
            if (fnc(val, i)) {
                return [[...acc[0], val], acc[1]];
            }
            return [acc[0], [...acc[1], val]];
        },
        [[], []]
    );
}
